var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUskl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    fillRule: "nonzero",
    d: "M13.586,2.023 C12.068,2.071 10.6215,2.677 9.5215,3.725 C7.9805,5.23 7.199,7.6165 7.199,10.8175 C7.199,15.1765 8.1735,18.3075 10.018,19.8725 C10.965,20.689 12.2005,21.091 13.447,20.9895 L13.609,20.9775 C15.912,20.9775 17.778,19.1105 17.778,16.8085 C17.778,14.5055 15.912,12.6395 13.609,12.6395 L13.609,10.36 C15.9115,10.391 17.8025,8.5505 17.8335,6.2485 C17.865,3.9465 16.0235,2.055 13.722,2.024 C13.6845,2.0235 13.6465,2.0235 13.609,2.024 L13.586,2.023 Z M13.082,23.0001225 C11.486,22.997 9.9435,22.427 8.7295,21.3925 C6.393,19.4085 5.2075,15.851 5.2075,10.8185 C5.2075,7.0405 6.203,4.165 8.162,2.272 C9.64,0.859 11.5995,0.0595 13.644,0.035 C17.0445,0.055 19.786,2.828 19.766,6.229 C19.753,8.3985 18.6005,10.401 16.7305,11.501 C19.6625,13.2255 20.6415,17.0005 18.9165,19.9325 C17.8225,21.7935 15.8335,22.945 13.675,22.9685 C13.478,22.9905 13.28,23.001 13.082,23.0001225 L13.082,23.0001225 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0B09",
    strokeWidth: 2,
    d: "M2.2275,3.623 L2.2275,19.412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    fillRule: "nonzero",
    d: "M0.0495,3.807 L1.9125,0.5805 C2.052,0.338 2.4025,0.338 2.5425,0.5805 L4.4055,3.807 C4.5455,4.0495 4.3705,4.3525 4.0905,4.3525 L0.364,4.3525 C0.084,4.3525 -0.091,4.0495 0.0495,3.807 M0.0495,19.228 L1.9125,22.4545 C2.052,22.697 2.4025,22.697 2.5425,22.4545 L4.4055,19.228 C4.5455,18.9855 4.3705,18.6825 4.0905,18.6825 L0.364,18.6825 C0.084,18.6825 -0.091,18.9855 0.0495,19.228"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUskl);
export default __webpack_public_path__ + "static/media/icon-uskl.1eb8c37df78d60599647e233d7c0aff8.svg";
export { ForwardRef as ReactComponent };